<template>
  <div class="min-h-screen">
    <TheToolbar @open-qr-scanner="openQrScanner" />

    <div class="layout-shell min-h-[calc(100vh-57px)] bg-zinc-100 dark:bg-[#1b1d22]" :style="layoutShellStyle">
      <aside
          v-if="!mustChangePassword"
          class="hidden lg:block sticky top-[57px] self-start h-[calc(100vh-57px)] overflow-hidden"
      >
        <div
            class="h-full overflow-hidden border-r border-zinc-200 bg-gray-50 dark:border-zinc-800 dark:bg-zinc-900 transition-[width] duration-[350ms] ease-in-out"
            :class="sidebarCollapsed ? 'w-[56px]' : 'w-[220px]'"
        >
          <TheSidebar
              :collapsed="sidebarCollapsed"
              :is-mobile="false"
              show-collapse-toggle
              @open-qr-scanner="openQrScanner"
              @toggle-collapse="toggleSidebarCollapse"
          />
        </div>
      </aside>

      <main class="min-w-0 flex-1 dark:bg-[#1b1d22]">
        <div :class="containerClasses">
          <router-view v-slot="{ Component }">
            <keep-alive
                v-if="$route.name !== 'ChangePassword'"
                max="10"
            >
              <component :is="Component" />
            </keep-alive>
            <component
                :is="Component"
                v-else
            />
          </router-view>
        </div>
      </main>
    </div>
  </div>

  <Drawer
      v-model:visible="showQrScanner"
      position="right"
      class="lg:hidden !w-full max-w-full p-0 border-0"
      :dismissable="true"
      :show-close-icon="false"
      modal
  >
    <template #container>
      <MobileQrScanner @close="showQrScanner = false" />
    </template>
  </Drawer>
</template>

<script>
import TheToolbar from "../components/TheToolbar.vue";
import TheSidebar from "../components/TheSidebar.vue";
import MobileQrScanner from "../components/MobileQrScanner.vue";
import { Drawer } from "primevue";
import { mapGetters } from "vuex";

export default {
  components: {
    TheToolbar,
    TheSidebar,
    MobileQrScanner,
    Drawer,
  },

  data() {
    return {
      showQrScanner: false,
      sidebarCollapsed: localStorage.getItem('layout_sidebar_collapsed') === '1',
    };
  },

  methods: {
    toggleSidebarCollapse() {
      this.sidebarCollapsed = !this.sidebarCollapsed;
      localStorage.setItem('layout_sidebar_collapsed', this.sidebarCollapsed ? '1' : '0');
    },
    openQrScanner() {
      this.showQrScanner = true;
    },
  },

  computed: {
    ...mapGetters([
      'user',
    ]),

    mustChangePassword() {
      return this.user?.mustChangePassword === true;
    },

    layoutShellStyle() {
      let sidebarWidth = '220px';
      if (this.mustChangePassword) {
        sidebarWidth = '0px';
      } else if (this.sidebarCollapsed) {
        sidebarWidth = '56px';
      }

      return {
        '--layout-sidebar-width': sidebarWidth,
      };
    },

    containerClasses() {
      if (this.$route.meta?.fullWidth) {
        return 'w-full p-0';
      }

      return 'w-full max-w-7xl mx-auto px-4 py-4';
    },
  },
};
</script>

<style scoped>
@media (min-width: 1024px) {
  .layout-shell {
    display: grid;
    grid-template-columns: var(--layout-sidebar-width) minmax(0, 1fr);
    transition: grid-template-columns 350ms ease-in-out;
  }
}
</style>
